import Vue from 'vue'
import Vuex from 'vuex'
import {Auth} from "aws-amplify";
import axios from "axios";
import CountryFlag from 'vue-country-flag'
import { apolloClient } from '../vue-apollo'
import moment from 'moment'
import gql from 'graphql-tag'
import { getNextToGo, isUserHasAccessToVenue } from '../common/methods'
import { VENUENAME, USERROLE }  from "../common/constants"
import * as jose from 'jose'

Vue.use(Vuex)

export const mapBetSlip = betslip => {
  return betslip.map(bets => {
    return {
      winPlc: bets.winPlc,
      selId: bets.selId,
      odds: bets.odds,
      stake: bets.stake,
      runnerNumber: bets.runnerNumber,
      runnerName: bets.runnerName,
      trackName: bets.trackName,
      trackNumber: bets.trackNumber,
      trackCountry: bets.trackCountry,
      ...bets
    }
  })
}
Vue.component('country-flag', CountryFlag)

const store = {
  state: {
    terminalId: "",
    playerCardId: null,
    venueName: "",
    nextToGoRaces: [],
    selectedMeeting: null,
    selectedRace: null,
    racePrices: [],
    signedIn: false,
    terminalFail: false,
    terminalFailMsg: null,
    openMeetingsModal: false,
    bets: [],
    priceCode: "",
    raceLoading: true,
    storedPayment: 0,
    meetings: {},
    races: {},
    terminalBranch: '',
    terminalLocation: null,
    terminalToken: null,
    processedBets: {},
    processingBets: {},
    printedBets: [],
    appVersion: {
      version: 0,
      stale: false
    },
    transactionReceipt: {},
    cashPosition: false,
    meetingsSubscription: null,
    raceSubscription: null,
    priceSubscription: null,
    detailedRace: {},
    transactionHistory: [],
    scannedTickets: [],
    multiRedemptionMode: false,
    wrapperVersion: null,
    lastAuthUser: null,
    lastAuthUserRole: USERROLE.ENDUSER,
    noCurrentUser: false,
    venueClientData: {},
    debugModeOn: false,
    axioRequestResponse: [],
    attendantCalled: false,
  },
  mutations: {
    setVenueClientData(state, v) {
      state.venueClientData = v
    },
    setWrapperVersion(state, version){
      state.wrapperVersion = version
    },
    setLoadBets(state, m){
      state.bets = m;
    },
    setPlayerCardId(state, id){
      state.playerCardId = id;
    },
    setTodaysMeetings(state, m){
      state.meetings.todaysMeetings = m;
    },
    setTomorrowsMeetings(state, m){
      state.meetings.tomorrowsMeetings = m;
    },
    setThirdsMeetings(state, m){
      state.meetings.thirdsMeetings = m;
    },
    selectMeeting (state, m) {
      state.selectedMeeting = m
    },
    setRace(state, selectedRace){
      state.selectedRace = selectedRace;
    },
    selectRace (state, m) {
      state.selectedRace = m
    },
    setPrices(state, racePrices){
      state.racePrices = racePrices;
    },
    setTerminalId(state, v) {
      state.terminalId = v
    },
    setVenueName(state, v) {
      state.venueName = v
    },
    setNextToGo(state, m) {
      state.nextToGoRaces = m
    },
    setSignedIn(state, m) {
      state.signedIn = m
    },
    setNoCurrentUser(state,v) {
      state.noCurrentUser = v
    },
    setTerminalFail(state, m) {
      state.terminalFail = m
    },
    setTerminalFailMsg(state, m) {
      state.terminalFailMsg = m
    },
    setMeetingsModal(state, m) {
      state.openMeetingsModal = m
    },
    setPriceCode(state, { priceCode }) {
      state.priceCode = priceCode
    },
    setRaceLoading(state, { isLoading }) {
      state.raceLoading = isLoading
    },
    setStoredPayment(state, m) {
      state.storedPayment = m
    },
    setMeetings(state, meetings) {
      const meetingsObj = {}
      meetings.forEach(meeting => {
        meetingsObj[meeting.id] = meeting
      })
      state.meetings = meetingsObj
    },
    setRaces(state, races) {
      const racesObj = {}
      races.forEach(race => {
        racesObj[race.id] = race
      })
      state.races = racesObj
    },
    updateRace(state, raceUpdate) {
      const race = state.races[raceUpdate.id]
      const detailedRace = state.detailedRace?.id === raceUpdate.id ? { ...state.detailedRace } : null
      if (detailedRace) {
        const competitors = raceUpdate?.competitors ?
          detailedRace.competitors.map(c => {
            return {
              ...c,
              ...raceUpdate.competitors.find(uc => c.tabNo === uc.tabNo)
            }
          }) : detailedRace.competitors
        const updatedRace = {
          ...detailedRace,
          status: raceUpdate.status,
          startTime: raceUpdate.startTime,
          competitors
        }
        Vue.set(state, 'detailedRace', updatedRace)
      }
      if (race) {
        const updatedRace = {
          ...race,
          status: raceUpdate.status,
          startTime: raceUpdate.startTime
        }
        Vue.set(state.races, raceUpdate.id, updatedRace)
        const meeting = state.meetings[race?.meeting?.id]
        if (meeting) {
          const races = [...meeting.races]
          races[races.findIndex(r => r.id === updatedRace.id)] = { ...race, ...updatedRace }
          const updatedMeeting = {
            ...meeting,
            races
          }
          Vue.set(state.meetings, updatedMeeting.id, updatedMeeting)
        }
      }
    },
    setProcessedBets(state, m) {
      state.processedBets = m
    },
    setProcessedBet(state, m) {
      const key = m.key
      Vue.set(state.processedBets, key, m)
    },
    clearProcessedBets(state) {
      state.processedBets = {}
    },
    setProcessingBets(state, bet) {
      const key = bet.key
      Vue.set(state.processingBets, key, bet)
    },

    clearProcessingBets(state) {
      state.processingBets = {}
    },
    setPrintedBets(state, bet) {
      state.printedBets.push(bet);
    },
    clearPrintedBets(state) {
      state.printedBets = []
    },
    loadEditedBet(state, bet) {
      const oldBets = state.bets
      var res = oldBets.map(obj => bet.find(prevBet => prevBet.selId === obj.selId) || obj)
      state.bets = res
    },
    setTransactionReceipt(state, transaction) {
      state.transactionReceipt = transaction
    },
    clearTransactionReceipt(state) {
      state.transactionReceipt = {}
    },
    setCashPosition(state, bool) {
      state.cashPosition = bool
    },
    setLocation(state, location) {
      state.terminalLocation = location
    },
    setBranch(state, branch) {
      state.terminalBranch = branch
    },
    setTerminalToken(state, token) {
      state.terminalToken = token
    },
    resetCashPosition(state) {
      state.cashPosition = false
    },
    setTransactionHistory(state, history) {
      state.transactionHistory = history
    },
    updateMeetingsSubscription(state, { subscription }) {
      if (state.meetingsSubscription) {
        state.meetingsSubscription.unsubscribe()
      }
      state.meetingsSubscription = subscription
    },
    updatePriceSubscription(state, { subscription }) {
      if (state.priceSubscription) {
        state.priceSubscription.unsubscribe()
      }
      state.priceSubscription = subscription
    },
    updateDetailedRaceSubscription(state, { subscription }) {
      if (state.raceSubscription) {
        state.raceSubscription.unsubscribe()
      }
      state.raceSubscription = subscription
    },
    clearDetailedRace(state) {
      const updatedRace = {}
      Vue.set(state, 'detailedRace', updatedRace)
    },
    updateDetailedRace(state, { race }) {
      const updatedRace = {
        ...race,
        competitors: race.competitors.map(c => {
          return {
            ...c,
            prices: c.prices.map(p => {
              return {
                ...p,
                id: race.id
              }
            })
          }
        })
      }
      Vue.set(state, 'detailedRace', updatedRace)
    },
    setScannedTickets(state,tickets){
      state.scannedTickets = tickets
    },
    setMultiRedemptionMode(state, multiMode) {
      state.multiRedemptionMode = multiMode
    },
    setLastAuthUser(state, userName){
      state.lastAuthUser = userName
    },
    setLastAuthUserRole(state, userRole){
      state.lastAuthUserRole = userRole
    },
    setDebugModeOn(state, isDebugModeOn){
      state.debugModeOn = isDebugModeOn
    },
    setAxioRequestResponse(state, data){
      state.axioRequestResponse = data
    },
    setAttendantCalled(state, data) {
      state.attendantCalled = data
    }
  },
  actions: {
    appendAxioLogs(context, data){
      context.commit('setAxioRequestResponse', [...context.state.axioRequestResponse, data])
    },
    updateDebugModeOn(context, isDebugModeOn){
      context.commit('setDebugModeOn', isDebugModeOn)
    },
    updateAttendantCalled(context, data) {
      console.log(data)
      context.commit('setAttendantCalled', data)
    },
    updateMultiRedemptionMode(context, multiMode) {
      context.commit('setMultiRedemptionMode',multiMode)
      if ( multiMode === false ) {
        context.commit('setScannedTickets',[] )
      }
    },
    updateScannedTickets(context,tickets) {
      context.commit('setScannedTickets',tickets)
    },
    setPlayerCardId (context, id) {
      context.commit('setPlayerCardId', id)
    },
    clearPlayerCardId (context) {
      context.commit('setPlayerCardId', null)
    },
    startVersionPolling (context) {
      function fetchVersion() {
        if (!window.location.href.includes('localhost')) {
          axios.get(`${process.env.VUE_APP_WRAPPER_URL}/config.json`,{
            withCredentials: false
          }).then(response => {
            const version = response.data.version
            if (context.state.appVersion.version === 0) {
              Vue.set(context.state.appVersion, 'version', version)
            }
            if (context.state.appVersion.version !== version) {
              Vue.set(context.state.appVersion, 'stale', true)
            }
          })
        }
      }
      fetchVersion()
      setInterval(() => {
        fetchVersion()
      }, 60000)
    },
    deleteBet(context, bet) {
      const currentBets = context.state.bets
      currentBets.forEach ((clearedBet, index) => {
        if (bet.selId === clearedBet.selId) {
          currentBets.splice(index, 1)
        }
      })
      context.state.bets = currentBets
    },
    loadEditedBet(context, bet) {
      context.commit('loadEditedBet', [bet])
    },
    setProcessedBets(context, m) {
      context.commit('setProcessedBets', m)
    },
    setProcessedBet(context, m) {
      console.log('setProcessedBet', m)
      context.commit('setProcessedBet', m)
    },
    clearProcessedBets(context) {
      context.commit('clearProcessedBets')
    },
    setProcessingBets(context, {bet, num}) {
      console.log('setProcessingBets', bet, num)
      if (!bet?.selId) return null
      const newBet = {
        ...bet
      }
      context.commit('setProcessingBets', newBet)
    },
    clearProcessingBets(context) {
      context.commit('clearProcessingBets')
    },
    setPrintedBets(context, bet) {
      context.commit('setPrintedBets', bet)
    },
    clearPrintedBets(context) {
      context.commit('clearPrintedBets')
    },
    setTransactionReceipt(context, transaction) {
      context.commit('setTransactionReceipt', transaction)
    },
    clearTransactionReceipt(context) {
      context.commit('clearTransactionReceipt')
    },
    setCashPosition(context, bool) {
      context.commit('setCashPosition', bool)
    },
    resetCashPosition(context) {
      context.commit('resetCashPosition')
    },
    setTransactionHistory(context, history) {
      context.commit('setTransactionHistory', history)
    },
    selectRace(context, id) {
      context.dispatch('fetchDetailedRace', { id, priceCode: context.state.priceCode})
      context.commit('selectRace', id)
    },
    setNextToGo (context) {
      const races = context.getters.getRaces
      const thisVenue = VENUENAME[context.getters.getVenueName]
      const result = races.find((b) => b.meeting.track.name === thisVenue && b.status === 'OPEN')
      const nextToGo = races ? getNextToGo(races) : []
      if (result) {
        context.commit('selectMeeting', result?.meeting?.id)
        context.dispatch('selectRace', result?.id)
      } else {
        context.commit('selectMeeting', nextToGo?.[0]?.meeting?.id)
        context.dispatch('selectRace', nextToGo?.[0]?.id)
      }
    },
    async fetchMeetings(context) {
      const todayDate = moment().startOf('day').subtract(12, 'h').format()
      // const tomorrowDate = moment().add(1,'d')
      const thirdDate = moment().startOf('day').add(3,'d').format()
      try {
        const result = await apolloClient.query({
          query: gql`{
            meetingsDated(date: ${JSON.stringify(todayDate)}, to: ${JSON.stringify(thirdDate)}){
              id,
              type,
              date,
              track{
                name,
                country
              },
              races{
                id,
                number,
                status,
                startTime
              }
            }
          }`
        })

        //filter based on track blacklist
        const meetings = result?.data?.meetingsDated?.filter(m => !context.state.venueClientData?.trackBlacklist || context.state.venueClientData?.trackBlacklist?.length == 0 || context.state.venueClientData?.trackBlacklist?.findIndex(b=> b.value?.toLowerCase() == m.track?.name?.toLowerCase()) == -1) || []
        meetings.sort((a, b) => b.track.country.localeCompare(a.track.country))
        const races = []
        meetings.forEach(m => {
          m.races.forEach(r => {
            races.push({ ...r, meeting: m})
          })
        })


        const nextToGo = races ? getNextToGo(races) : []
        const race = races.find(r => r.id === context.state.selectedRace)
        const currentVenueName = VENUENAME[context.getters.getVenueName]
        const currentVenueRace= races.find((b) => b.meeting.track.name === currentVenueName && b.status === 'OPEN')
        // default current race to current venue's first race
        if (currentVenueRace) {
          context.commit('selectMeeting', currentVenueRace?.meeting?.id)
          context.dispatch('selectRace', currentVenueRace?.id)
        }
        else if (race && race?.id === context.state.selectedRace) {
          context.dispatch('selectRace', race?.id)
        } else {
          context.commit('selectMeeting', nextToGo?.[0]?.meeting?.id)
          context.dispatch('selectRace', nextToGo?.[0]?.id)
        }

        context.commit('setMeetings', meetings )
        context.commit('setRaces', races)
        context.dispatch('subscribeRaceUpdates')
      } catch (error) {
        console.log(error)
      }
    },
    async subscribeRaceUpdates(context) {
      try {
        const result = await apolloClient.subscribe({
          query: gql`subscription{
            raceUpdated{
              id,
              number,
              status,
              startTime
            }
          }`
        })
        const subscription = result.subscribe({
          next (data) {
            const raceUpdated = data?.data?.raceUpdated
            if (!raceUpdated) return null
            context.commit('updateRace', raceUpdated)
          }
        })
        context.commit('updateMeetingsSubscription', { subscription })
      } catch (error) {
        console.log(error)
      }
    },
    async fetchDetailedRace (context, { id, priceCode }) {
      await context.dispatch('getPriceCode')
      context.commit('clearDetailedRace')
      try {
        priceCode = context.state.priceCode
        context.dispatch('setRaceLoading', true)
        const result = await apolloClient.query({
          query: gql`{
            race(id: ${JSON.stringify(id)}){
              id,
              number,
              name,
              status,
              startTime,
              competitors{
                tabNo,
                barrier,
                scratched,
                name,
                jockey,
                finalPosition,
                selectionID(source: ${JSON.stringify(priceCode)})
                prices(sources: [${JSON.stringify(priceCode)}]){
                  tabNo,
                  type,
                  price
                },
              },
              results(sources: ["BET"]){
                positions{
                  tabNo,
                  position
                }
              }
              meeting{
                id,
                type
                track {
                  name,
                  country

                },
                externalIDs(sources: "gbs"){
                  id
                },
              }
            }
          }`
        })
        context.dispatch('setRaceLoading', false)
        const race = result?.data?.race
        context.commit('updateDetailedRace', { race })
        context.dispatch('subscribePrices', { id, priceCode })
        context.dispatch('subscribeDetailedRace', { id })
      } catch (error) {
        context.dispatch('setRaceLoading', false)
        console.log(error)
      }
    },
    async getNewPrice (context, { id, type, tabNo }) {
      try {
        const result = await apolloClient.query({
          query: gql`{
            race(id: ${JSON.stringify(id)}){
              id,
              priceSets(sources: ${JSON.stringify([context.state.priceCode])}) {
                type
                prices {
                  tabNo,
                  type,
                  price
                }
              }
            }
          }`
        })
        const prices = result?.data?.race?.priceSets
        const priceSet = prices?.find(p => p.type === type).prices
        const newPrice = priceSet?.find(p => p.tabNo === tabNo)?.price
        return newPrice
      } catch (error) {
        console.log(error)
      }
    },
    async subscribePrices(context, { id, priceCode }) {
      try {
        const result = await apolloClient.subscribe({
          query: gql`subscription{
            priceUpdates(raceId: ${JSON.stringify(id)}, sources: [${JSON.stringify(priceCode)}]){
              updated,
              prices{
                tabNo,
                price,
                type
              }
            }
          }`
        })
        const subscription = result.subscribe({
          next (subscriptionData) {
            const prices = subscriptionData?.data?.priceUpdates?.prices?.map(p => {
              return {
                ...p,
                price: p?.price ? Math.round(p.price * 100) / 100 : null
              }
            })

            const race = { ...context.state.detailedRace }
            if (race?.id !== id) return
            const competitors = race?.competitors?.map(c => {
              const price = prices.find(p => p.tabNo === c.tabNo)
              price.id = id
              if (price) {
                const otherPrice = c.prices.filter(p => p?.type !== price?.type)
                return {
                  ...c,
                  prices: [price, ...otherPrice]
                }
              }
            })
            const updatedRace = {
              ...race,
              competitors
            }
            context.commit('updateDetailedRace', { race: updatedRace })
          }
        })
        context.commit('updatePriceSubscription', { subscription })
      } catch (error) {
        console.log(error)
      }
    },
    async subscribeDetailedRace(context, { id }) {
      try {
        const result = await apolloClient.subscribe({
          query: gql`subscription{
            raceUpdated(raceId: ${JSON.stringify(id)}){
              id,
              number,
              status,
              startTime,
              competitors{
                tabNo,
                barrier,
                scratched,
                name,
                jockey,
                finalPosition,
              }
            }
          }`
        })
        const subscription = result.subscribe({
          next (subscriptionData) {
            const raceUpdate = subscriptionData?.data?.raceUpdated
            context.commit('updateRace', raceUpdate)
          }
        })
        context.commit('updateDetailedRaceSubscription', { subscription })
      } catch (error) {
        console.log(error)
      }
    },
    clearStorePayment(context) {
      context.commit('setStoredPayment', 0)
    },
    storePayment(context, amount) {
      context.commit('setStoredPayment', amount)
    },
    loadPriceCode(context, priceCode) {
      context.commit('setPriceCode', { priceCode })
    },
    loadBets(context, v) {
      const bets = context.state.bets
      context.commit('setLoadBets', [...bets,v])
    },
    clearBets(context) {
      context.dispatch('setNextToGo')
      context.commit('setLoadBets', [])
    },
    clearSelectedBets(context, bets) {
      const filteredBets = context.state.bets.filter(bet => !bets.includes(bet.selId))
      context.commit('setLoadBets', filteredBets)
    },
    setTerminalId(context, v) {
      context.commit('setTerminalId', v)
    },
    setVenueName(context, v) {
      context.commit('setVenueName', v)
    },
    selectMeeting (context, m) {
      context.commit('selectMeeting', m)
    },
    setTerminalFail (context, m) {
      context.commit('setTerminalFail', m)
    },
    setMeetingsModal (context, m) {
      context.commit('setMeetingsModal', m)
    },
    setTerminalFailMsg (context, m) {
      context.commit('setTerminalFailMsg', m)
    },
    setLocation (context, m) {
      context.commit('setLocation', m)
    },
    setBranch (context, m) {
      context.commit('setBranch', m)
    },
    async signIn (context) {

      const config = {
        withCredentials:false
      }
      const checkGroup = await Auth.currentAuthenticatedUser()
      try{
        if (isUserHasAccessToVenue(checkGroup.signInUserSession.accessToken.payload['cognito:groups'],context.getters.getVenueName)) {
          const res = await axios.post(`${process.env.VUE_APP_LEDGER_ENDPOINT}public/ValidateTerminal`, { ba_terminalid: context.state.terminalId, dual_token: true }, config)
          await context.dispatch('fetchVenueClientData')
          context.commit('setLocation', res.data.terminalLocation)
          if (window.onewatch) {
            window.onewatch.sendWindowId(res.data.terminalLocation)
          }
          context.commit('setBranch', res.data.terminalBranch)
          context.commit('setTerminalToken', res.data.jwt)
          window.localStorage.setItem('BMterminalToken',res.data.jwt)
          context.commit('setSignedIn', true)
          context.dispatch('fetchMeetings')
          context.dispatch ('mountNextToGo')
        } else {
          context.dispatch('signOut')
        }
      }
      catch(err){
        console.log(err)
        // const message = err?.response?.data?.message
        context.commit('setTerminalFail', true)
        if( err.response ){
          context.commit('setTerminalFailMsg', err)
        }else{
          context.commit('setTerminalFailMsg', {response:{data:{message:"Network Error"}}})
        }

      }
    },
    async signOut (context) {
      console.log('signout')
      context.commit('setSignedIn', false)
      await Auth.signOut()
    },
    async sessionOut(context){
      console.log('signout')
      context.commit('setSignedIn', false)
      context.commit('setNoCurrentUser', false)
      await Auth.signOut()
    },
    async mountNextToGo () {
      // const nextToGoRaceLoad = context.getters.getNextToGo().filter(race => race.type === 'R' && race.fixedOddsEnabled === true)?.reduce((earliestRace, race) => {
      // return (race.startDatetime <= earliestRace.startDatetime) ? race : earliestRace
      // }, []);

      // context.dispatch ('selectRace', nextToGoRaceLoad.id)
      // context.dispatch ('loadRunners', nextToGoRaceLoad.id)
    },
    setRaceLoading (context, isLoading) {
      context.commit('setRaceLoading', { isLoading })
    },
    updateLastAuthUser(context, userName){
      context.commit('setLastAuthUser', userName)
    },
    updateLastAuthUserRole(context, userRole){
      context.commit('setLastAuthUserRole', userRole)
    },
    async getTerminalToken(context){
      // if no terminal token or token expiring in 5 mins, refresh with a new token
      if (!context.state.terminalToken || (context.state.terminalToken && jose.decodeJwt(context.state.terminalToken).exp * 1000 < ((new Date()).getTime() + 5 * 60 * 1000))){
        const res = await axios.post(`${process.env.VUE_APP_LEDGER_ENDPOINT}public/ValidateTerminal`, { ba_terminalid: context.state.terminalId, dual_token: true },{
          withCredentials:false
        })
        context.commit('setTerminalToken',res.data.jwt)
        window.localStorage.setItem('BMterminalToken',res.data.jwt)
        return res.data.jwt
      }else{
        return context.state.terminalToken
      }

    },
    async getPriceCode(context){
      if (!context.state.priceCode){
        try{
          const token = await context.dispatch('getTerminalToken')
          const res2 = await axios.post(`${process.env.VUE_APP_LEDGER_ENDPOINT}public/GetVenueClientData`, { terminal_token: token },{
            withCredentials:false
          })
          if(res2.data.ClientData.PriceCode){
            context.dispatch('loadPriceCode',res2.data.ClientData.PriceCode)
          }
          else{
            throw new Error("no price code");
          }
        }
        catch(e){
          console.log(e)
          const sources = await apolloClient.query({
            query: gql`{
              sources {
                code,
                name,
                gbsCode,
                isPriceSource
              }
            }`
          })

          const source = sources?.data?.sources?.[0]?.code
          const isSource = sources?.data?.sources?.[0]?.isPriceSource
          if (isSource) {
            context.dispatch('loadPriceCode', source)
          } else {
            context.dispatch('loadPriceCode', 'UB')
          }

        }


      }
      return context.state.priceCode

    },

    async fetchVenueClientData(context){
        const token = await context.dispatch('getTerminalToken')
        const res = await axios.post(`${process.env.VUE_APP_LEDGER_ENDPOINT}public/GetVenueClientData`, { terminal_token: token },{
          withCredentials:false
        })
        if(res.data.ClientData){
          context.commit('setVenueClientData',res.data.ClientData)
        }
    }
  },
  getters: {
    getWrapperVersion (state) {
      return state.wrapperVersion
    },
    getMultiRedemptionMode(state){
      return state.multiRedemptionMode
    },
    getScannedTickets(state){
      return state.scannedTickets
    },
    getPrintedBets (state) {
      return state.printedBets
    },
    getProcessingBets (state) {
      return state.processingBets
    },
    getProcessedBets (state) {
      return state.processedBets
    },
    getRaces (state) {
      return Object.values(state.races)
    },
    getMeetings (state) {
      return Object.values(state.meetings)
    },
    hasFeature () {
      return function (feature) {
        const features = process.env.VUE_APP_FEATURE_FLAGS.split(',')
        return features.some((x) => x.trim() === feature.trim())
      }
    },
    getBetSlip (state) {
      return state.bets
    },
    getStoredPayment (state) {
      return state.storedPayment
    },
    getTerminalId (state) {
      return state.terminalId
    },
    getTerminalLocation (state) {
      return state.terminalLocation
    },
    getTerminalBranch(state) {
      return state.terminalBranch
    },
    getPlayerCardId (state) {
      return state.playerCardId
    },
    getVenueName(state) {
      return state.venueName
    },
    getSelectedMeeting (state) {
      return state.meetings[state.selectedMeeting]
    },
    getTodaysMeetings (state) {
      return function () {
        return state.meetings.todaysMeetings
      }
    },
    getTomorrowsMeetings (state) {
      return function () {
        return state.meetings.tomorrowsMeetings
      }
    },
    getNextToGo (state) {
      return function () {
        return state.nextToGoRaces
      }
    },
    getSelectedRace (state) {
      if (state.detailedRace === {}) {
        return {}
      }
      return state.detailedRace
    },
    // getTodaysFilteredMeetings (state) {
    //   return state.meetings.todaysMeetings.filter(meeting => meeting.type === 'R')
    // },
    getLastAuthUser: (state) =>{
      return state.lastAuthUser
    },
    getLastAuthUserRole: (state) =>{
      return state.lastAuthUserRole
    }
  },
}


export default store
